'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function safeDivide(dividend, divisor) {
  if (!divisor) {
    return 0;
  }

  return dividend / divisor;
}
function minMax(min, value, max) {
  return Math.min(max, Math.max(min, value));
}

exports.minMax = minMax;
exports.safeDivide = safeDivide;
